import { ref, Ref } from 'vue';
import {storeToRefs} from 'pinia';
import { ToggleButtonData } from 'components/global-common/ToggleButtonData.model';
import { useLayoutStore } from 'stores/layout-store';
import { QTableProps } from 'quasar';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';

const MAX_TOGGLE = 3;

const SEX_OPTIONS = [
  {
    value: '1',
    label: 'Male'
  },
  {
    value: '2',
    label: 'Female'
  },
  {
    value: '3',
    label: 'Unknown'
  }];


function createTogglePaneList(): Ref<Array<ToggleButtonData>> {

  const { codesSelected, searchSelected, referencesSelected, resourcesSelected } = storeToRefs(useLayoutStore());

  return ref([
    {
      id: 1,
      label: 'Codes',
      pressed: codesSelected,
      disabled: false,
    },
    {
      id: 2,
      label: 'Search',
      pressed: searchSelected,
      disabled: false,
    },
    {
      id: 3,
      label: 'References',
      pressed: referencesSelected,
      disabled: false,
    },
    {
      id: 4,
      label: 'Resources',
      pressed: resourcesSelected,
      disabled: false,
    },
  ]);
}

const SUBMIT_OPTIONS: SubmitOption[] = [
  {
    value: 'working',
    label: 'Working'
  },
  {
    value: 'initial',
    label: 'Initial'
  },
  {
    value: 'possible',
    label: 'Possible'
  }
];

const baseDxColumns: QTableProps['columns'] = [
  {name: 'left-spacer', align: 'center', label: '', field: 'left-spacer', sortable: false},
  {name: 'action', align: 'center', label: '', field: 'action', sortable: false},
  {name: 'pdx', align: 'center', label: '', field: 'pdx', sortable: false},
  {name: 'modifier', align: 'center', label: 'DRG Modifier', field: 'drgModifier', sortable: false},
  {name: 'code', align: 'left', label: 'Code', field: 'code', sortable: false},
  {name: 'desc', align: 'left', label: 'Diagnoses Description', field: 'description', sortable: false},
  {name: 'poa', align: 'center', label: 'POA', field: 'poa', sortable: false}
];

const compactOnlyDxColumns: QTableProps['columns'] = [
  {name: 'quality-risk', align: 'center', label: 'Quality/Risk', field: 'quality-risk', sortable: false, headerClasses: 'io-mfe-ig-dx-pane-actions text-left'}
];

const fullScreenOnlyDxColumns: QTableProps['columns'] = [
  {name: 'quality', align: 'center', label: 'Quality', field: 'quality', sortable: false, headerClasses: 'io-mfe-ig-dx-pane-quality text-left'},
  {name: 'risk', align: 'center', label: 'Risk', field: 'risk', sortable: false, headerClasses: 'io-mfe-ig-dx-pane-risk text-left'}
];

function getDxColumns(layoutMode: GrouperLayoutMode) {
  const layoutColumns = (layoutMode == GrouperLayoutMode.consolidated ? compactOnlyDxColumns : fullScreenOnlyDxColumns) || [];
  return baseDxColumns?.concat(layoutColumns);
}

type SubmitOption = {
  value: string,
  label: string
}

export { MAX_TOGGLE, SEX_OPTIONS, createTogglePaneList, SUBMIT_OPTIONS, getDxColumns, SubmitOption }